import React from "react";
import {LinkTo} from "./PrivacyPolicy.styles";

const PrivacyPolicyData = [
    {
        id: 16,
        title: `PRIVACY POLICY`,
        content: '',
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `DRIVOSITY PRIVACY POLICY`,
        content: (
            <>
                Drivosity, LLC (“Drivosity,” “we,” “us,” and “our”) respects the importance of the privacy of your personal information.  We provide this Privacy Policy so you know about our information handling and storage practices and understand how we collect, protect, use, and share the personal information we receive about you from your use of websites and web applications under <span className='underline'>drivosity.com</span> and other Drivosity websites on which this Privacy Policy appears or is referenced (collectively, the “<span className='drv-bold'>Site</span>”), the Drivosity mobile software application (the “<span className='drv-bold'>App</span>”), or otherwise in connection with our other products or services.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `DRIVOSITY PRIVACY POLICY`,
        content: (
            <>
                By accessing or using the Site or the App or interacting with us in connection with our products or services, you agree to the terms of this Privacy Policy.  Except to the extent use of the Site or App involves additional authorization and conditions, in which case additional data may be collected and other rules applied, this Privacy Policy shall apply.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `DRIVOSITY PRIVACY POLICY`,
        content: (
            <>
                Your visit to the Site and any dispute over privacy is subject to the <LinkTo title="https://drivosity.com/terms-of-use/" to="/terms-of-use/" className="underline">Terms of Use</LinkTo>, including limitations on damages and application of the law of the State of Florida.  Use of the Site is strictly voluntary. <span className='drv-bold'>If you do not agree to our Privacy Policy and Terms of Use, you must immediately log off the Site and may not use the Site.</span>  Additionally, we may not be able to assist you in connection with matters relating to our products or services.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `YOUR CONSENT`,
        content: (
            <>
                BY SUBMITTING YOUR PERSONAL INFORMATION TO US, YOU ARE CONSENTING TO THE COLLECTION AND PROCESSING OF YOUR PERSONAL INFORMATION IN THE UNITED STATES AND TO OUR USE OF YOUR PERSONAL INFORMATION AND ANY RELATED INFORMATION IN THE MANNER DESCRIBED IN THIS PRIVACY POLICY, INCLUDING THE TRANSMISSION TO, AND STORAGE AND PROCESSING OF YOUR PERSONAL INFORMATION BY THIRD PARTIES OUTSIDE THE UNITED STATES.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `YOUR CONSENT`,
        content: (
            <>
                IF YOU ARE SUBMITTING PERSONAL INFORMATION OF THIRD PARTIES TO US, YOU WARRANT AND REPRESENT YOU HAVE THEIR CONSENT TO PROVIDE THEIR PERSONAL INFORMATION TO US AND YOU WILL INDEMNIFY US AND HOLD US HARMLESS FROM AND AGAINST CLAIMS BY SUCH INDIVIDUALS RELATING TO OUR PROCESSING AND USE OF SUCH PERSONAL INFORMATION WITHIN THE TERMS OF THIS PRIVACY POLICY.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `THE DATA WE COLLECT`,
        content: (
            <>
                <span className='italic'>Anonymous Electronic Information.</span> In general, you can browse the Site without telling us who you are or revealing any personal information about yourself.  However, we collect your computer’s or mobile device’s IP address, which you necessarily disclose when you visit the Site or download or use the App so that data (such as the web pages you request) can be sent to your computer or device.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `THE DATA WE COLLECT`,
        content: (
            <>
                <span className='italic'>Cookies.</span> The Site or App may utilize “cookies,” which are text files placed on your computer or device that web pages or screens may use to store data on your computer or mobile device or send data to our web servers.  We may use cookie data to “recognize” you when you return to the Site or the App, to save your user ID, to track usage information, to troubleshoot how the Site or App operates, and for internal analysis of how people use the Site or App.  Should you decide not to accept cookies from the Site or App, you will limit the functionality we can provide you.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `THE DATA WE COLLECT`,
        content: (
            <>
                <span className='italic'>Additional Electronic Information.</span> We may use standard Internet technology, such as web beacons, tracking pixels, and other similar tracking technologies, to track your use of the Site or App.  We may also use identifiers for mobile devices in the App (e.g., Android Advertising Identifier or Advertising Identifier for iOS) or similar technology that are used to collect data, such as type of device, operating system information, carrier, network type, and other unique device identifiers.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `THE DATA WE COLLECT`,
        content: (
            <>
                Currently, our servers do not respond to browser “do not track” signals.  If you would like more information regarding online marketing practices and know your choices about not having this information used by our third party service providers, you may visit <LinkTo title="http://www.networkadvertising.org/choices" to="http://www.networkadvertising.org/choices" className="underline">www.networkadvertising.org/choices</LinkTo>.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `THE DATA WE COLLECT`,
        content: (
            <>
                <span className='drv-bold italic'>Location Information.</span> We collect information about your device’s location, which can be precise (e.g., latitude/longitude data) or imprecise (e.g., location derived from an IP address or data that indicates a city or postal code level). For example, we may collect precise location through the Drivosity software platform to allow our customers, their customers, and authorized personnel to track the location of Drivers and their deliveries.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `THE DATA WE COLLECT`,
        content: (
            <>
                <span className='italic'>Through Your Interactions with Us.</span> When you engage in certain activities on the Site or App or otherwise interact with us, such as requesting a product demo, purchasing or using one of our driving solution products, contacting us for support or other inquiries, we may ask you to provide personal and other information.  The information we will require will depend on the activity.  If you do not provide the mandatory information for a particular activity, you will not be able to engage in that activity. You may also limit your ability to use all or a portion of the Site or App.  If you are a registered user of the Site or App, we may track when and how you use the Site or App and the operations you perform on the Site or App.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `THE DATA WE COLLECT`,
        content: (
            <>
                <span className='italic'>Information Obtained from Other Sources.</span> We may obtain information about you from other companies and organizations, such as from your employer. We may combine such information with information we have collected or may collect about you. We are not responsible for the accuracy of any information provided by other sources or the data practices of other sources.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                Generally, we process and use personal information to provide and improve our products and services, including the Site and the App, for purposes in our legitimate interests and for compliance with applicable laws. More specifically: 
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                <span className='italic'>To Operate Our Business.</span> We process personal information where you have given us your consent or on the basis that it is: (a) necessary to enter into or perform a contract we have with you; (b) in our or a third parties’ legitimate interests such as a contract with your employer under which we are required to deliver products or services; or (c) for compliance with a legal obligation. Some of our lawful bases for processing your personal information stem from our customers.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                We may use your personal information for particular activities, including, without limitation, providing products and services to you or your employer, customer service, billing, processing your order, technical support, collections, marketing and research, developing and displaying content and advertising tailored to your interests, providing product, promotional and other information to you, sending you messages and notifications, and to contact you regarding administrative notices or to solicit feedback on your experience with us. 
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                Depending on the circumstances and the nature of the information, we may share this information with our affiliated entities, distributors, marketing partners, and other parties with whom we collaborate.  If we are collecting your personal information under a contract with your employer, we may share your personal information with your employer.  We must release your billing information to service providers and financial institutions to process your payments for products or services purchased on or through this Site.  In addition, if we use service providers, these service providers may have access to your personal information to perform contractually specified services on our behalf.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                <span className='italic'>To Improve our Business.</span> We may use your IP address and similar Site or App usage information to, among other things: (i) help diagnose problems with the Site or App, administer and improve the Site or App, and measure the use of the Site or App; (ii) identify the type of web browsers used, the pages viewed, the websites from which a visitor found the Site or App, and the search terms and search engines used to find the Site or App; and (iii) gather other analytics information relating to use and navigation of the Site or App.  This information does not identify you personally.  On occasion we may aggregate this data with data from other users to track overall visitor traffic and usage patterns and provide this aggregate information to vendors, business partners, or affiliates.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                The information we obtain using standard Internet technology, such as web beacons, tracking pixels, and other similar technologies, enables us to customize the services we offer visitors to the Site, to deliver targeted content and advertisements, and to measure the overall effectiveness of our online content, advertising, programming or other activities.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                We may use your location information to provide personalized content and advertising, to enhance your experience with the Site or App, to assist us with analytics, and to improve the effectiveness of our Site or App.  Where we are collecting your location information as part of a contract with your employer (e.g., you are a Driver), we may share and use that information to provide products and services to your employer under that contract.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                We may use the information in an anonymous or aggregated format that does not identify you personally, which uses might include, without limitation, to evaluate existing products, services, and systems; to assist in the development of new products or services; research; advertising; and to identify trends and changes.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                <span className='italic'>For Law Enforcement, Regulators and Other Parties for Legal Reasons.</span> We may also disclose personal information in any of the following circumstances: (a) in response to a subpoena, search warrant, court order, or other legal process or request, or as may otherwise be required by law, rule, or regulation; (b) to protect and defend our rights or property or those of our affiliates or business partners, or others; or (c) as we, in our sole discretion, believe is appropriate under exigent circumstances in response to a perceived threat to the personal safety, property, or rights of any person or organization.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                In addition, since our database is a business asset, in the event we are reorganized or become part of another organization, you consent to the sale, assignment, or transfer of your personal information to a successor that acquires substantially all of our business assets, or to an affiliate, as applicable.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `USE OF THE DATA WE COLLECT`,
        content: (
            <>
                We do not sell personal information to third parties. Other than as set forth in this Privacy Policy, we do not transfer, share or disclose personal information to third parties.  We do not disclose personal information of individuals we know to be under the age of 16 to other businesses or third parties for consideration.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `DRIVERS`,
        content: (
            <>
                The Drivosity platform (which include the Site and App) collects information to allow Drivosity’s customers and others to track the location of Drivers, their delivery orders, and statistics gathered during the order delivery process. If you are an employee or independent contractor of a Drivosity customer who delivers food and other products to their customers (“Drivers”), you understand that we may process information collected about you through your use of the Drivosity platform in accordance with this Privacy Policy, including for analytics purposes and to provide services for our customers.  In order to use the Drivosity platform, you may have to agree to in-application permissions or consents.  If you are a Driver and a California resident, you understand that personal information collected about you is used solely within the context of your role as an employee or contractor of our customer; we are collecting, using and sharing that information to provide products and services to our customer.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `OUR RELATIONSHIP TO OTHER WEBSITES`,
        content: (
            <>
                The Site or App may contain links to other websites. If you visit one of these other websites, we encourage you to review the privacy policy on that website.  We are not responsible for the policies and practices of other websites, and any information you submit to those websites is subject to their privacy policies.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `OUR RELATIONSHIP TO OTHER WEBSITES`,
        content: (
            <>
                We may have functionality on the Site that is provided, in whole or in part, by a third party service provider.  You can usually identify such third party functionality by the use of a trademark not owned by us on or near the functionality.  In that case, when you use the functionality, you become subject to the terms of use and privacy policy of this third party in addition to the Privacy Policy and Terms of Use of our Site.  In some cases, you may need to visit that party’s website and locate the terms of use and privacy policy.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `SECURITY OF PERSONAL INFORMATION`,
        content: (
            <>
                We take the security of personal information seriously and we take what we believe to be reasonable precautions and have implemented certain safeguards to protect the security of data and personal information. We may transmit your personal information to third parties outside the United States for storage or processing. We will attempt to ensure that your personal information will be subject to appropriate safeguards and that it is processed and secured in accordance with applicable law.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `SECURITY OF PERSONAL INFORMATION`,
        content: (
            <>
                However, we cannot guarantee against any loss, misuse, unauthorized disclosure, or alteration or destruction of data or personal information. While we strive to protect your personal information, we do not guarantee the security of any information you transmit to or from the Site or App or by email or otherwise, and you provide such information at your own risk. You acknowledge that: (a) there are security and privacy limitations in computer systems and on the Internet which are beyond our control; (b) the security, integrity, and privacy of any and all information and data exchanged between you and us through the Site or App, including personal information, cannot be guaranteed; and (c) any such information and data may be viewed or tampered with by a third party while such information or data is being used, transmitted, processed, or stored.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },

    {
        id: 16,
        title: `PRIVACY RIGHTS AND REQUESTS`,
        content: (
            <>
                Depending on where you reside, you may have rights under applicable laws concerning personal information we have collected about you, which may include the right to access your personal information we have, to ask us to delete, correct, or restrict the use of your personal information, to withdraw your consent to our use of your personal information, to ask how we have used your personal information, and to ask whether we have shared your personal information. We will honor your rights to the extent required by us under applicable law or as we may agree to honor in our sole discretion.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `PRIVACY RIGHTS AND REQUESTS`,
        content: (
            <>
                All privacy requests relating to your personal information, including those related to access to, rectification of, restriction of, processing of, sharing of, or objection to the processing of your personal information, withdrawal of consent to handle your personal information, the right to be forgotten, or to opt-out of the sale of your personal information (in case our policy changes), can be submitted to us one of the following ways:
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `PRIVACY RIGHTS AND REQUESTS`,
        content: (
            <>
                <div className='mb-7'>
                    By email: <a href="mailto:support@drivosity.com" className="cursor-pointer">support@drivosity.com</a>
                </div>
                By U.S. Mail: Drivosity, LLC, Attention: Chief Privacy Officer, 290 Citrus Tower Blvd. Suite 236, Clermont, FL 34711
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `PRIVACY RIGHTS AND REQUESTS`,
        content: (
            <>
                All communications must be in the English language.  Please clearly state what information you are requesting and any other requests you are making.  You can designate an authorized agent to submit requests on your behalf. However, we will require written proof of the agent’s permission to do so and verify your identity directly.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `PRIVACY RIGHTS AND REQUESTS`,
        content: (
            <>
                We will respond to reasonable requests within the time limits established by applicable law or within a reasonable time if no time limit is established by applicable law.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `PRIVACY RIGHTS AND REQUESTS`,
        content: (
            <>
                If you or your authorized agent sends us an email requesting that we take action regarding your personal information or the right to be forgotten, the requesting email MUST come from the email address we have on file for you in order to verify that the request is valid and also to protect your personal information.  All other requests must be made in writing or otherwise be verifiable as originating from you or your authorized agent.  In order to protect your information and because people may have the same name, we will only provide or delete personal information that we can verify is associated with your particular email address or where we can reasonably identify the identity of the requestor. If you are an employee, contractor or customer of our customer, we may forward your request to them.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `PRIVACY RIGHTS AND REQUESTS`,
        content: (
            <>
                For your protection, we may ask you for additional information to verify your identity.  In most cases, we will provide the information you request and correct or delete any inaccurate personal information you discover. We reserve the right, however, to limit or deny your request to the extent permitted by applicable law if: (a) complying with the request may present a threat to the personal safety, property, or rights of any other person or organization; (b) complying with the request may lead to a violation of applicable laws or regulations; (c) we are not required to comply with the request because of a legal rule or exception; or (d) you have failed to provide us with sufficient evidence to verify your identity.  We will also not delete personal information if that personal information is related to an ongoing transaction.  Even after a request, we may also keep personal information where necessary to comply with applicable laws or where necessary to protect a legal right or fulfill a legal obligation.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `HOW LONG WE KEEP PERSONAL INFORMATION`,
        content: (
            <>
                We store the personal information we collect about you for as long as is necessary for the purpose(s) for which we collected it, or for other legitimate business purposes, including to meet our legal, regulatory, or other compliance obligations.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `CHANGES TO PRIVACY POLICY`,
        content: (
            <>
                We reserve the right to revise this Privacy Policy, in whole or in part, at any time without notice to you. You expressly waive any right to receive notice of any revisions to this Privacy Policy. We encourage you to review this Privacy Policy regularly in your use of the Site or App to ensure you are aware of current practices. Any use of the Site or App following the date on which the revised Privacy Policy is published on the Site shall constitute your acceptance of all such changes.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `DRIVOSITY GO - MOBILE APPLICATION`,
        content: (
            <>
                <span className='italic'>Additional Privacy Terms:&nbsp;</span> Use of the ‘Drivosity Go’ mobile application is governed by this Privacy Policy as well as the following additional terms:
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `DRIVOSITY GO - MOBILE APPLICATION`,
        content: (
            <>
                <span className='italic'>“App Personal Data” We Collect through the App:&nbsp;</span> Name, email, phone number, user ID.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `DRIVOSITY GO - MOBILE APPLICATION`,
        content: (
            <>
                <span className='italic'>Use and Sharing of App Personal Data:&nbsp;</span> Your name, email address, phone number and user ID are collected and used for account management and App functionality and are required to enable use of the App. For example, we require your name and/or user ID in order to provide you delivery order information in the App from your employer. Your email address and phone number are only used for password retrieval. App Personal Data is shared with your employer as well as any third-party service providers we may utilize in order to provide our services to your employer.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `DRIVOSITY GO - MOBILE APPLICATION`,
        content: (
            <>
                <span className='italic'>Requests to Delete 'Drivosity Go' App Personal Data:&nbsp;</span> 'Drivosity Go' App users must initiate the request to delete their App Personal Data through their employer, who will notify us and authorize us to process the request.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `DRIVOSITY GO - MOBILE APPLICATION`,
        content: (
            <>
                <span className='italic'>“Client-Customer Data”</span>, including name, delivery address, and order information about their customers may be provided to us by our customers for the purpose of performing specific contracted services. For example, we may provide Client-Customer Data to delivery drivers employed by our customers to allow them to perform the delivery services requested by their own customers. We use Client-Customer Data only as contractually permitted to provide services on behalf of our customers and per the terms of this Privacy Policy. The collection, use and sharing of Client-Customer data is governed by the terms of our customers’ own privacy policies. We encourage you to review those policies to better understand our customers’ use of personal information they collect. If you are a California resident and would like information regarding personal information collected and used by our customers who utilize our services, please contact the customer directly.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `CONTACT`,
        content: (
            <>
                For questions or comments related to this Privacy Policy, please email us at <a title="mailto:support@drivosity.com" href="mailto:support@drivosity.com" className='drv-link underline'>support@drivosity.com</a>.
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    },
    {
        id: 16,
        title: `CONTACT`,
        content: (
            <>
                <div className='mb-16 italic'>
                    Last updated: September 5, 2023
                </div>
                4889-7630-3742, v. 2
            </>
        ),
        location: `/privacy-policy`,
        data: null,
    }
];

export {PrivacyPolicyData};
